
/* Protopia Ecosystem component */
export interface IContentEditBackProps {
   
}
const ContentEditBack = (props: IContentEditBackProps): JSX.Element => {
    return <>
        <div className='pe-content-edit-back '>
        
        </div>
        
    </>
}
export default ContentEditBack